import { ListKeyManager } from '@angular/cdk/a11y';
import { DOWN_ARROW, ENTER, UP_ARROW } from '@angular/cdk/keycodes';
import {
  AfterViewInit,
  Component,
  Input,
  QueryList,
  ViewChildren,
  OnDestroy
} from '@angular/core';
import { delay, filter, takeUntil } from 'rxjs/operators';
import { BusinessNavKeybindService } from '../../../keybind.service';
import { BusinessNavLocationService } from '../location.service';
import { BusinessNavLocationTabService } from '../tab/tab.service';
import { LocationListItemComponent } from './location-list-item/location-list-item.component';
import { Subject } from 'rxjs';

@Component({
  selector: 'atlas-location-list',
  templateUrl: './location-list.component.html',
  styleUrls: ['./location-list.component.scss']
})
export class LocationListComponent implements AfterViewInit, OnDestroy {
  @ViewChildren(LocationListItemComponent) locationItems: QueryList<
    LocationListItemComponent
  >;
  @Input() locations: Location[] = [];

  private _destroyed$$: Subject<void> = new Subject<void>();

  keyManager: ListKeyManager<LocationListItemComponent>;

  constructor(
    private tabService: BusinessNavLocationTabService,
    private locationService: BusinessNavLocationService,
    private keybindService: BusinessNavKeybindService
  ) {}

  ngAfterViewInit(): void {
    this.keyManager = new ListKeyManager<LocationListItemComponent>(
      this.locationItems
    ).withWrap();
    this.keyManager.skipPredicate(
      (item: LocationListItemComponent) => !!item.isCurrentLocation
    );

    // Reset the currently selected item when the list changes.
    this.locationItems.changes
      .pipe(
        delay(100),
        takeUntil(this._destroyed$$)
      )
      .subscribe(() => {
        if (!this.keyManager) {
          return;
        }
        this.keyManager.setActiveItem(-1);
      });

    // enter to enter location/brand
    this.keybindService.keyEvent$
      .pipe(
        filter((event: KeyboardEvent) => event.keyCode === ENTER),
        takeUntil(this._destroyed$$)
      )
      .subscribe(() => {
        if (this.keyManager.activeItemIndex === -1) {
          return;
        }
        this.switchLocation(this.keyManager.activeItem);
      });

    this.keybindService.keyEvent$
      .pipe(
        filter(
          (event: KeyboardEvent) =>
            event.keyCode === UP_ARROW || event.keyCode === DOWN_ARROW
        ),
        takeUntil(this._destroyed$$)
      )
      .subscribe((event: KeyboardEvent) => {
        this.keyManager.onKeydown(event);
        this.keyManager.activeItem.onScroll();
      });
  }

  switchLocation(location: LocationListItemComponent): void {
    location.goToLocation();
  }

  ngOnDestroy(): void {
    this._destroyed$$.next();
    this._destroyed$$.complete();
  }
}
